var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.account.role != "admin"
    ? _c(
        "div",
        [
          !_vm.$store.state._StoreWatcheeBox.isConnected
            ? _c(
                "v-menu",
                { attrs: { bottom: "", left: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { slot: "activator", icon: "" },
                      slot: "activator"
                    },
                    [
                      _c("v-icon", { attrs: { color: "grey" } }, [
                        _vm._v("warning")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-card-text",
                        [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm._f("cap")(_vm.$t("connectionChatLost"))
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { block: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.reload()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("reconnection")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _c(
                "v-menu",
                {
                  directives: [
                    {
                      name: "scroll",
                      rawName: "v-scroll",
                      value: _vm.onScroll,
                      expression: "onScroll"
                    }
                  ],
                  attrs: { bottom: "", left: "" },
                  model: {
                    value: _vm.menu,
                    callback: function($$v) {
                      _vm.menu = $$v
                    },
                    expression: "menu"
                  }
                },
                [
                  !_vm.$vuetify.breakpoint.smAndDown && !_vm.isMobile
                    ? _c(
                        "v-btn",
                        {
                          staticStyle: { width: "150px" },
                          attrs: { slot: "activator", small: "", light: "" },
                          slot: "activator"
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("cap")(_vm.$t(_vm.selectStatus.value))
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                right: "",
                                color: _vm.selectStatus.color
                              }
                            },
                            [_vm._v("person_pin")]
                          )
                        ],
                        1
                      )
                    : _vm.isMobile
                    ? _c(
                        "v-btn",
                        {
                          staticStyle: { width: "150px" },
                          attrs: { slot: "activator", small: "", light: "" },
                          slot: "activator"
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("cap")(_vm.$t(_vm.selectStatus.value))
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            { attrs: { color: _vm.selectStatus.color } },
                            [_vm._v("person_pin")]
                          )
                        ],
                        1
                      )
                    : _c(
                        "v-icon",
                        {
                          attrs: {
                            slot: "activator",
                            color: _vm.selectStatus.color
                          },
                          slot: "activator"
                        },
                        [_vm._v("person_pin")]
                      ),
                  _vm._v(" "),
                  _c(
                    "v-list",
                    { staticClass: "card", attrs: { avatar: "", dense: "" } },
                    _vm._l(_vm.statusAgent, function(item) {
                      return _c(
                        "v-list-tile",
                        {
                          key: item.value,
                          attrs: {
                            disabled:
                              item.value == "busy" && !_vm.user.canBeUnavailable
                          },
                          on: {
                            click: function($event) {
                              item.value != "busy" || _vm.user.canBeUnavailable
                                ? _vm.switchToStatus(item.value)
                                : _vm.$store.dispatch("_Notifier/NEW_NOTIF", {
                                    message: _vm.$t("noSwitchUnavailable"),
                                    context: "warning"
                                  })
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "text--darken-2 mr-1",
                              attrs: { color: item.color, left: "" }
                            },
                            [_vm._v("person_pin")]
                          ),
                          _vm._v(" "),
                          _c("v-list-tile-title", [
                            _vm._v(_vm._s(_vm._f("cap")(_vm.$t(item.value))))
                          ])
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-82665c5a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82665c5a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzAgentStatus.vue
// module id = null
// module chunks = 